export default "__VITE_ASSET__DPjFPJko__"